/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockStopwatchIcon16Light = forwardRef('TimeClockStopwatchIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 4.25a.5.5 0 0 1 .5.5V8.5a.5.5 0 0 1-1 0V4.75a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 1v1.019a6.5 6.5 0 1 0 5.436 2.252l1.168-1.167a.5.5 0 0 0-.708-.708L11.73 3.564A6.472 6.472 0 0 0 8 2.019V1h1.5a.5.5 0 0 0 0-1h-4a.5.5 0 0 0 0 1H7ZM2 8.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" })));
});
